export default {
  ja:[
    "アイテム作成",
    "商品名",
    "メーカー名",
    "商品のカテゴリー(例:　フィギュア",
    "キャラクター名",
    "他にもキャラクターを登録する",
    "値段(送料込み, 日本円, 500円以上)",
    "値段に送料を含みますか？",
    "商品状態",
    "新品",
    "中古",
    "メッセージ",
    "アイテム作成",
  ],
  en: [
    "New Item",
    "item name",
    "item maker name",
    "What is item category?",
    "item's character name",
    "+add more character",
    "price(including shipping fee, JPY, more than 500JPY)",
    "Include shipping fee?",
    "state",
    "New",
    "Used",
    "message",
    "register",
  ]
}
